import { useQuery } from 'react-query';
import { CACHE_1_HOUR_MS } from '../../../config/utils/cacheUtils';
import {
  Country,
  Currency,
  CustomerType,
  CustomerVatRegime,
  VatExceptionCategory,
} from '../../../interfaces/customer.interface';
import { apiRQ } from '../../api';

export interface CustomerFormData {
  customerTypes: CustomerType[];
  currency: Currency[];
  customerVatRegimes: CustomerVatRegime[];
  vatExceptionCategories: VatExceptionCategory[];
  countries: Country[];
}

export const getCustomerFormData = async (): Promise<CustomerFormData> => {
  const resp = await apiRQ.get<CustomerFormData>('/form-data/customer');

  return resp.data;
};

export const useCustomerForm = () => {
  return useQuery<CustomerFormData, Error>(['useCustomerForm'], () => getCustomerFormData(), {
    cacheTime: CACHE_1_HOUR_MS,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
